import { useTranslation } from 'react-i18next'
import AvailabilitySlotPicker from './AvailabilitySlotPicker'

function AvailabilityForm({
	formState,
	formError,
	onSubmit,
	onFieldChange,
	onSlotToggle,
	onCancel,
	saving,
	submitDisabled = false,
	mode = 'create',
}) {
	const { t } = useTranslation()
	const isEditMode = mode === 'edit'
	const primaryLabel = isEditMode
		? t('trainingAvailability.edit.actions.submit')
		: t('trainingAvailability.add.actions.submit')
	const busyLabel = isEditMode
		? t('trainingAvailability.edit.actions.submitting')
		: t('trainingAvailability.add.actions.submitting')

	return (
		<section>
			<div className="mb-3">
				<h3 className="text-base font-semibold text-gray-900">{t('trainingAvailability.form.title')}</h3>
				<p className="text-sm text-gray-500">{t('trainingAvailability.form.description')}</p>
			</div>

			<form onSubmit={onSubmit} className="space-y-5">
				<div className={`grid gap-4 ${isEditMode ? '' : 'sm:grid-cols-2'}`}>
					<div>
						<label className="mb-1 block text-sm font-medium text-gray-700" htmlFor="availability-date-from">
							{isEditMode ? t('trainingAvailability.form.fields.date') : t('trainingAvailability.form.fields.dateFrom')} *
						</label>
						<input
							id="availability-date-from"
							type="date"
							value={formState.dateFrom || ''}
							onChange={e => onFieldChange('dateFrom', e.target.value)}
							className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500"
						/>
					</div>

					{isEditMode ? null : (
						<div>
							<label className="mb-1 block text-sm font-medium text-gray-700" htmlFor="availability-date-to">
								{t('trainingAvailability.form.fields.dateTo')} *
							</label>
							<input
								id="availability-date-to"
								type="date"
								value={formState.dateTo || ''}
								onChange={e => onFieldChange('dateTo', e.target.value)}
								className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500"
							/>
						</div>
					)}
				</div>

				<div>
					<label className="mb-2 block text-sm font-medium text-gray-700">
						{t('trainingAvailability.form.fields.slots')} *
					</label>
					<AvailabilitySlotPicker selectedSlots={formState.slots} onSlotToggle={onSlotToggle} />
				</div>

				<div>
					<label className="mb-1 block text-sm font-medium text-gray-700" htmlFor="availability-notes">
						{t('trainingAvailability.form.fields.notes')}
					</label>
					<textarea
						id="availability-notes"
						rows={4}
						value={formState.notes}
						onChange={e => onFieldChange('notes', e.target.value)}
						className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500"
						placeholder={t('trainingAvailability.form.placeholders.notes')}
					/>
				</div>

				{formError && <p className="text-sm text-red-600">{formError}</p>}

				<div className="flex flex-col gap-3 sm:flex-row sm:justify-end">
					<button
						type="button"
						onClick={onCancel}
						className="rounded-md border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50">
						{t('trainingAvailability.form.actions.cancel')}
					</button>
					<button
						type="submit"
						disabled={saving || submitDisabled}
						className={`rounded-md px-4 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${
							saving || submitDisabled ? 'cursor-not-allowed bg-indigo-400' : 'bg-indigo-600 hover:bg-indigo-500'
						}`}>
						{saving ? busyLabel : primaryLabel}
					</button>
				</div>
			</form>
		</section>
	)
}

export default AvailabilityForm
